import React, { useState } from 'react';
import { connect, useSelector } from 'react-redux';

import ZRMUtils from '@zg-rentals/zrm-utils-js/lib/utils';

import { RoutingSelectors } from 'app/shared/selectors';
import { withErrorBoundary } from 'app/shared/components/ErrorBoundary';

import AuthCheckWrapper from 'app/shared/containers/AuthCheckWrapper';
import PermissionCheck from 'app/shared/components/PermissionCheck';

import { PageBreadcrumb, TextButton } from '@zillow/constellation';

import PageWizard from 'app/shared/components/PageWizard';
import HowItWorks from 'app/shared/components/WizardRentGuarantee/HowItWorks';
import PriceYourRental from 'app/shared/components/WizardRentGuarantee/PriceYourRental';
import VerifySecurityDeposit from 'app/shared/components/WizardRentGuarantee/VerifySecurityDeposit';
import OnlineTools from 'app/shared/components/WizardRentGuarantee/OnlineTools';
import Confirmation from 'app/shared/components/WizardRentGuarantee/Confirmation';

import { RENT_GUARANTEE_PATH } from 'app/shared/constants/RouteConstants';

import {
    DEEP_LINK_STEP,
    PROGRESS_STEP,
    PROGRESS_STEP_CONFIG,
    STEP,
} from './constants';

import {
    StyledContainer,
} from './StyledComponents';

const propTypes = {};
const defaultProps = {};

const RentGuaranteePage = () => {
    const search = useSelector(state => RoutingSelectors.makeSearch(state));
    const paramStep = ZRMUtils.queryUtils.parse(search.toString()).step;
    const initialDeepLinkStep = DEEP_LINK_STEP[paramStep];
    const [currentStepKey, setCurrentStepKey] = useState(initialDeepLinkStep || STEP.HOW_IT_WORKS);
    const config = [
        {
            stepKey: STEP.HOW_IT_WORKS,
            wizardBodyTemplate: HowItWorks,
            hideProgressStepper: true,
        },
        {
            stepKey: STEP.PRICE_YOUR_RENTAL,
            wizardBodyTemplate: PriceYourRental,
            progressStepKey: PROGRESS_STEP.PRICE_YOUR_RENTAL,
            hideProgressStepper: false,
        },
        {
            stepKey: STEP.VERIFY_SECURITY_DEPOSIT,
            wizardBodyTemplate: VerifySecurityDeposit,
            progressStepKey: PROGRESS_STEP.VERIFY_SECURITY_DEPOSIT,
            hideProgressStepper: false,
        },
        {
            stepKey: STEP.ONLINE_TOOLS,
            wizardBodyTemplate: OnlineTools,
            progressStepKey: PROGRESS_STEP.ONLINE_TOOLS,
            hideProgressStepper: false,
        },
        {
            stepKey: STEP.CONFIRMATION,
            wizardBodyTemplate: Confirmation,
            progressStepKey: PROGRESS_STEP.CONFIRMATION,
            hideProgressStepper: false,
        },
    ];

    const handleGoToStep = (key) => {
        window.scroll(0, 0);
        setCurrentStepKey(key);
    };

    return (
        <AuthCheckWrapper requireStrongAuthentication={false}>
            <PermissionCheck route={RENT_GUARANTEE_PATH}>
                <StyledContainer>
                    <PageWizard
                        steps={config}
                        progressSteps={PROGRESS_STEP_CONFIG}
                        currentStepKey={currentStepKey}
                        onGoToStep={handleGoToStep}
                        breadCrumb={(
                            <PageBreadcrumb
                                backButton={(
                                    <TextButton>
                                        Exit Rent Guarantee
                                    </TextButton>
                                )}
                            />
                        )}
                    />
                </StyledContainer>
            </PermissionCheck>
        </AuthCheckWrapper>
    );
};

RentGuaranteePage.propTypes = propTypes;
RentGuaranteePage.defaultProps = defaultProps;

export { RentGuaranteePage };
export default withErrorBoundary(connect()(RentGuaranteePage));
